export default __webpack_public_path__ + "cd24b20a1fd19c5bc81eb033357c726a.svg";